<template>
    <div class="row" style="margin-top: 3px;" :id="this.oid">

        <!-- Option Properties -->
        <div class="col-md-3 quiz-left-column option-row"
             v-bind:class="{'text-success': isCorrect, 'text-danger': !isCorrect}">
            <input type="hidden" :name="'questions['+questionIdx+'][options]['+idx+'][oid]'" :value="oid"/>

            <i class="fa" v-bind:class="{'fa-check': isCorrect, 'fa-times': !isCorrect}"></i>
            <input type="hidden" :name="'questions['+questionIdx+'][options]['+idx+'][isCorrect]'" :value="isCorrect" />
            <select v-model="isCorrect" title="isCorrect" style="width:90%;" :disabled="correctnessDisabled">
                <option :value="false">Incorrect</option>
                <option :value="true">Correct</option>
            </select>
            <br />
            <button v-if="
                        questionType==='freeText' &&
                        !isSuggestedAnswer &&
                        XX_en.trim() !== ''"
                    type="button"
                    class="btn btn-default" style="color:#444;"
                    @click="setSuggestedAnswer">Set As Suggested Answer
            </button>
            <span v-if="isSuggestedAnswer" style="font-weight: bold; color:#444">Suggested Answer</span>
        </div>

        <!-- Option Text -->
        <div class="col-md-8 quiz-text-column option-row">
            <input type="hidden" :name="'questions['+questionIdx+'][options]['+idx+'][text][XX_en]'" :value="XX_en"/>
            <input type="text"
                   :disabled="disabled"
                   v-model="XX_en"
                   dir="auto"
                   onfocus="preview(this.value);"
                   @keyup="changeOptionText(XX_en)"/>
        </div>

        <!-- Delete-Button -->
        <div class="col-md-1 quiz-settings option-row" v-bind:class="{'pointer': canBeDeleted}" @click="removeOption()">
            <span v-if="canBeDeleted"><i class="fa fa-times"></i></span>
        </div>
    </div>
</template>


<script>
    export default {
        props: {
            'iisCorrect': Boolean,
            'iXX_en': String,
            'disabled': Boolean,
            'correctnessDisabled': Boolean,
            'idx': Number,
            'questionIdx': Number,
            'oid': String,
            'canBeDeleted': Boolean,
            'isSuggestedAnswer': Boolean,
            'questionType': String,
        },


        // the initial props are overwritten whenever the parent issues a re-rendering
        // (e.g. on adding/deleting questions/options), so we store them when the component
        // is loaded the first time, so we keep the user's changes.
        data: function () {
            return {
                isCorrect: this.iisCorrect,
                XX_en: this.iXX_en ? this.iXX_en : '',
                updateTimer: null,  // make sure that we don't add multiple options when typing very fast
            };
        },

        methods: {
            setSuggestedAnswer(){
                this.$emit('setSuggestedAnswer', this.oid);
            },

            changeOptionText: function (text) {
                // make sure that we don't add multiple options when typing very fast
                if (this.updateTimer !== null) {
                    window.clearTimeout(this.updateTimer);
                }

                let vm = this;

                this.updateTimer = window.setTimeout(function () {
                    preview(text);
                    vm.$emit('typingOption');
                }, 50);

            },

            removeOption: function () {
                if (this.canBeDeleted && confirm('Do you really want to remove this option?')) {
                    $('#' + this.oid).slideUp(500);
                    let that = this;
                    window.setTimeout(function () {
                        that.$emit('delete');
                    }, 500);
                }
            }
        },
    };
</script>
